export default __webpack_public_path__ + "static/media/glintt.05d8d0d5.png";